import _ from 'lodash/fp';

const filterConfig = {
  filter(plan, { values }) {
    return (values || [])
      .map(v => v.value)
      .includes(_.get('custom_styles', plan));
  },
  collectValues(plans) {
    const customStyles = _.flow(
      _.map(plan => ({
        value: _.get('custom_styles', plan),
      })),
      _.filter('value'),
      _.uniqBy('value'),
      _.sortBy('value'),
    )(plans);
    return customStyles;
  },
  labelRender: ({ value }) => value,
};

export default filterConfig;



// WEBPACK FOOTER //
// ./src/customFilters/Plans/CustomStyles.js